export default "__VITE_ASSET__61122fb8__"